import { ContractorServiceTypeTradeTermResponse } from "@/models/api/administration/contractors/ContractorServiceTypeTradeTermResponse";
import { ContractorTradeTerm } from "@/models/api/administration/contractors/ContractorTradeTerm";
import { ContractorTradeTermAddEdit } from "@/models/api/administration/contractors/ContractorTradeTermAddEdit";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import CancellableHelper from "@/requests/CancellableHelper";

//#region routes
export const URL_GET_CONTRACTOR_SERVICE_TYPES_TRADE_TERM_PAGED =
  "/ContractorAdministration/${ContractorId}/ServiceTypes/HasTradeTerm/Paged";
export const URL_GET_CONTRACTOR_TRADE_TERMS =
  "/ContractorAdministration/${ContractorId}/ServiceType/${ServiceTypeId}/TradeTerms";
export const URL_POST_ADD_CONTRACTOR_TRADE_TERMS =
  "/ContractorAdministration/${ContractorId}/ServiceType/${ServiceTypeId}/TradeTerms/Add";

export const URL_POST_EDIT_TRADE_TERM = "/TradeTerm/${TradeTermId}/Edit";
export const URL_POST_REMOVE_TRADE_TERM = "/TradeTerm/${TradeTermId}/Remove";

//#endregion

const _getContractorServiceTypesTradeTermPaged = new CancellableHelper<ContractorServiceTypeTradeTermResponse>(
  URL_GET_CONTRACTOR_SERVICE_TYPES_TRADE_TERM_PAGED,
  ContractorServiceTypeTradeTermResponse
);
_getContractorServiceTypesTradeTermPaged.jsonSerializer = true;
export const getContractorServiceTypesTradeTerm = async (
  genericTableRequest: GenericTableRequest,
  contractorId: string
): Promise<ContractorServiceTypeTradeTermResponse> => {
  return _getContractorServiceTypesTradeTermPaged.get({
    ContractorId: contractorId,
    ...genericTableRequest,
  });
};

const _getContractorTradeTerms = new CancellableHelper<Array<ContractorTradeTerm>>(
  URL_GET_CONTRACTOR_TRADE_TERMS,
  ContractorTradeTerm
);
export const getContractorTradeTerms = async (
  contractorId: string,
  serviceTypeId: number
): Promise<Array<ContractorTradeTerm>> => {
  return _getContractorTradeTerms.get({
    ContractorId: contractorId,
    ServiceTypeId: serviceTypeId,
  });
};

const _addContractorTradeTerms = new CancellableHelper<string>(URL_POST_ADD_CONTRACTOR_TRADE_TERMS);
export const addContractorTradeTerms = async (
  contractorId: string,
  serviceTypeId: number,
  body: ContractorTradeTermAddEdit
): Promise<string> => {
  return _addContractorTradeTerms.post(
    {
      ContractorId: contractorId,
      ServiceTypeId: serviceTypeId,
    },
    body
  );
};

const _editTradeTerm = new CancellableHelper<null>(URL_POST_EDIT_TRADE_TERM);
export const editTradeTerm = async (tradeTermId: string, body: ContractorTradeTermAddEdit): Promise<null> => {
  return _editTradeTerm.post(
    {
      TradeTermId: tradeTermId,
    },
    body
  );
};

const _removeTradeTerm = new CancellableHelper<null>(URL_POST_REMOVE_TRADE_TERM);
export const removeTradeTerm = async (tradeTermId: string): Promise<null> => {
  return _removeTradeTerm.post({ TradeTermId: tradeTermId });
};
